export default {
    baseStyle: {
        container: {
            maxWidth: '1100px',
            width: '100%',
            margin: '0 auto',
            padding: {base: '15px', lg: '30px 40px 0px 40px'},
            sx: {
                '.swiper-button-prev, .swiper-button-next': {
                    top: '-60px',
                    backgroundColor: 'transparent'
                },
                '.swiper-button-next': {
                    right: '0px'
                },
                '.swiper-button-prev': {
                    right: '47px'
                },
                '.swiper': {
                    overflow: 'visible',
                    overflowX: 'clip'
                },
                '.swiper-wrapper': {
                    display: 'flex'
                },
                '.swiper-slide': {
                    width: 'fit-content',
                    marginRight: '10px',
                    flexShrink: 0
                }
            }
        },
        heading: {
            color: 'black.100',
            as: 'h3',
            fontSize: '24px',
            fontWeight: '400',
            fontFamily: 'caslon',
            mb: 5
        },
        link: {
            _hover: {
                textDecoration: 'none'
            }
        },
        linkText: {
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'gray.800',
            borderRadius: '15px',
            textAlign: 'center',
            fontSize: '14px',
            padding: '5px 15px',
            color: 'black.100',
            _hover: {
                textDecoration: 'none',
                cursor: 'pointer'
            }
        }
    }
}
